/**
 * エラーアイコン
 */
export const caution = `<div class="emergency" style="z-index:280; position:absolute; top:0; right:-5px; width:40%; height:40%;">
<svg version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="width: 100%; height: 100%; opacity: 1;" xml:space="preserve">
    <g>
      <path class="st0" d="M437.014,74.978C390.77,28.696,326.608-0.014,256,0C185.393-0.014,121.222,28.696,74.977,74.978
        C28.696,121.222-0.015,185.392,0,256c-0.015,70.608,28.696,134.778,74.977,181.022C121.222,483.304,185.393,512.015,256,512
        c70.608,0.015,134.77-28.696,181.014-74.978c46.289-46.244,75-110.414,74.986-181.022
        C512.014,185.392,483.304,121.222,437.014,74.978z M399.474,112.526c36.763,36.799,59.414,87.355,59.43,143.474
        c-0.015,56.118-22.667,106.674-59.43,143.474c-36.807,36.763-87.363,59.416-143.474,59.43
        c-56.119-0.014-106.674-22.667-143.474-59.43C75.762,362.674,53.111,312.118,53.096,256
        c0.014-56.118,22.666-106.674,59.429-143.474c36.8-36.763,87.356-59.415,143.474-59.43
        C312.111,53.112,362.667,75.763,399.474,112.526z"></path>
      <path class="st0" d="M246.681,303.592c0.312,2.075,1.349,4.067,3.104,5.986c1.748,1.911,3.822,2.866,6.215,2.866
        c5.57,0,8.681-2.948,9.311-8.852l18.644-143.214c0.311-2.533,0.474-6.126,0.474-10.748c0-7.17-2.466-13.689-7.4-19.593
        c-4.94-5.889-11.948-8.837-21.029-8.837c-9.415,0-16.496,3.022-21.266,9.066c-4.778,5.904-7.171,12.356-7.171,19.364
        c0,4.31,0.156,7.888,0.474,10.748L246.681,303.592z"></path>
      <path class="st0" d="M256,390.792c8.118,0,14.962-2.778,20.548-8.362c5.57-5.563,8.356-12.422,8.356-20.541
        c0-8.126-2.785-14.978-8.356-20.556c-5.414-5.422-12.266-8.126-20.548-8.126c-8.118,0-14.971,2.8-20.556,8.364
        c-5.578,5.585-8.356,12.348-8.356,20.318c0,7.637,2.778,14.407,8.356,20.303C241.029,387.934,247.882,390.792,256,390.792z"></path>
    </g>
</svg>
</div>
`;

/**
 * 作業員（設備）アイコン
 * @param className
 */
export const equipments = (className: string = '') => `<div class="map cleaning ${className}">
    <svg version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="width: 100%; height: 100%; opacity: 1;" xml:space="preserve">
    <style type="text/css">
    </style>
    <g>
      <path class="st0" d="M332.998,291.918c52.2-71.895,45.941-173.338-18.834-238.123c-71.736-71.728-188.468-71.728-260.195,0
        c-71.746,71.745-71.746,188.458,0,260.204c64.775,64.775,166.218,71.034,238.104,18.844l14.222,14.203l40.916-40.916
        L332.998,291.918z M278.488,278.333c-52.144,52.134-136.699,52.144-188.852,0c-52.152-52.153-52.152-136.717,0-188.861
        c52.154-52.144,136.708-52.144,188.852,0C330.64,141.616,330.64,226.18,278.488,278.333z" ></path>
      <path class="st0" d="M109.303,119.216c-27.078,34.788-29.324,82.646-6.756,119.614c2.142,3.489,6.709,4.603,10.208,2.46
        c3.49-2.142,4.594-6.709,2.462-10.198v0.008c-19.387-31.7-17.45-72.962,5.782-102.771c2.526-3.228,1.946-7.898-1.292-10.405
        C116.48,115.399,111.811,115.979,109.303,119.216z" ></path>
      <path class="st0" d="M501.499,438.591L363.341,315.178l-47.98,47.98l123.403,138.168c12.548,16.234,35.144,13.848,55.447-6.456
        C514.505,474.576,517.743,451.138,501.499,438.591z" ></path>
    </g>
    </svg>
</div>`;

/**
 * 作業員（植栽）アイコン
 * @param className
 */
export const greening = (className: string = '') => `<div class="map cleaning ${className}">
    <svg version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 512 512" style="width: 100%; height: 100%; opacity: 1;" xml:space="preserve">
    <g>
      <path class="st0" d="M494.758,381.889l-30.281-47.641c-12.5-19.688-31.953-32.563-53.063-37.25
        c-16.031-3.594-33.219-2.484-49.203,3.766c-24.469,5.281-38.078-11.594-46.594-24.969l-18.031-28.391l88.078-184.391
        c11.875-28.75,7.219-49.484-14.047-63.016L256.008,181.967L140.398-0.002c-21.281,13.531-25.922,34.266-14.063,63.016
        l88.078,184.391l-18.031,28.391c-8.516,13.375-22.125,30.25-46.594,24.969c-15.969-6.25-33.156-7.359-49.203-3.766
        c-21.109,4.688-40.563,17.563-53.063,37.25l-30.281,47.641C4.727,401.576,1.352,424.654,6.07,445.732
        c4.672,21.109,17.547,40.547,37.234,53.047c19.688,12.516,42.766,15.906,63.844,11.188c21.094-4.688,40.563-17.547,53.063-37.25
        l30.281-47.641c12.516-19.672,15.891-42.766,11.172-63.859c-1.109-4.984-2.688-9.891-4.719-14.641
        c14.203-22.359,20.531-31.109,29.969-47.156c9.188-15.641,19.531-24.391,29.094-29.188c9.547,4.797,19.891,13.547,29.078,29.188
        c9.438,16.047,15.766,24.797,29.969,47.156c-2.016,4.75-3.609,9.656-4.719,14.641c-4.719,21.094-1.344,44.188,11.188,63.859
        l30.266,47.641c12.516,19.703,31.969,32.563,53.063,37.25c21.078,4.719,44.156,1.328,63.844-11.188
        c19.688-12.5,32.563-31.938,37.234-53.047C510.648,424.654,507.273,401.576,494.758,381.889z M157.023,403.811l-30.266,47.656
        c-6.734,10.547-16.922,17.266-28.234,19.813c-11.313,2.5-23.391,0.75-33.953-5.953c-10.547-6.703-17.266-16.906-19.813-28.203
        c-2.5-11.328-0.734-23.406,5.953-33.969l30.281-47.656c6.703-10.547,16.891-17.266,28.219-19.813
        c11.313-2.5,23.391-0.75,33.953,5.953c10.547,6.703,17.266,16.906,19.813,28.219C165.477,381.17,163.727,393.264,157.023,403.811z
         M255.664,243.779c-7.641,0-13.813-6.188-13.813-13.813s6.172-13.813,13.813-13.813c7.625,0,13.813,6.188,13.813,13.813
        S263.289,243.779,255.664,243.779z M467.242,437.123c-2.547,11.297-9.266,21.5-19.813,28.203s-22.641,8.453-33.953,5.953
        c-11.313-2.547-21.5-9.266-28.219-19.813l-30.281-47.656c-6.688-10.547-8.438-22.641-5.938-33.953
        c2.531-11.313,9.25-21.516,19.813-28.219c10.547-6.703,22.625-8.453,33.953-5.953c11.313,2.547,21.5,9.266,28.219,19.813
        l30.281,47.656C467.992,413.717,469.742,425.795,467.242,437.123z" ></path>
    </g>
    </svg>
</div>`;

/**
 * 作業員（清掃）アイコン
 * @param className
 */
export const cleaning = (className: string = '') => `<div class="map cleaning ${className}">
    <svg version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="width: 100%; height: 100%; opacity: 1;" xml:space="preserve">
        <style type="text/css">
          .st0{fill:#ffcc00;}
        </style>
        <g>
          <path class="st0" d="M332.571,140.81l-16.665,16.648c-41.547-24.17-95.688-18.468-131.288,17.116l153.521,153.52
            c35.583-35.592,41.294-89.732,17.115-131.278l16.666-16.657L332.571,140.81z" ></path>
          <path class="st0" d="M0,299.943c0,0,9.585,18.251,28.989,45.303c14.864-9,51.042-31.664,90.012-61.833l6.324,6.332
            c0,0-42.7,39.908-82.445,74.058c5.748,7.405,12.09,15.206,19.026,23.278c21.441-18.549,45.223-39.781,62.447-57.014l8.756,4.865
            c0,0-29.692,31.691-60.914,63.788c6.558,7.279,13.584,14.701,21.079,22.196c18.954,18.954,37.494,34.692,54.158,47.448
            c16.576-19.124,44.934-52.032,53.69-63.482l9.712,11.665c0,0-26.052,39.42-40.502,68.401
            c26.269,17.935,43.907,26.331,43.907,26.331c31.331-54.654,114.695-169.502,114.695-169.502L172.997,185.825
            C172.997,185.825,98.372,248.208,0,299.943z" ></path>

           <rect x="334.304" y="62.854" transform="matrix(0.7071 -0.7071 0.7071 0.7071 67.7361 328.4017)" class="st0" width="191.963" height="39.163" ></rect>
        </g>
        </svg>
    </div>`;

/**
 * ロボットアイコン
 * @param className
 */
export const robo = (className: string = '') => `
<div class="map robot ${className}">
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 478.165 478.165" style="enable-background:new 0 0 478.165 478.165; width:100%;height:100%;" xml:space="preserve">
        <g>
            <path id="Robo.to" fill="#00f" d="M279.916,190.907c0-9.543,7.631-17.393,17.254-17.393c9.464,0,17.074,7.85,17.074,17.393
        c0,9.563-7.631,17.333-17.074,17.333C287.546,208.221,279.916,200.471,279.916,190.907z M226.341,43.015h-0.139v23.789h21.856
        V43.732c7.511-3.805,12.671-11.576,12.671-20.601C260.669,10.32,250.429,0,237.817,0c-12.711,0-22.972,10.32-22.972,23.111
        C214.845,31.678,219.488,39.03,226.341,43.015z M178.604,208.221c9.504,0,17.234-7.77,17.234-17.333
        c0-9.543-7.73-17.393-17.234-17.393c-9.523,0-17.254,7.85-17.254,17.393C161.351,200.471,169.061,208.221,178.604,208.221z
        M237.817,478.165c25.881,0,47.876-16.736,56.304-39.807H181.553C189.881,461.429,211.917,478.165,237.817,478.165z
        M58.446,407.655c0-9.225,5.32-17.154,13.03-20.82v-98.382c0-19.465,14.982-35.305,33.89-36.639v-47.518
        c0,0,4.622-86.687,76.227-113.724c21.238-7.969,40.624-11.197,57.479-11.835c16.855,0.657,36.301,3.865,57.479,11.855
        c71.605,26.937,76.188,113.723,76.188,113.723v47.737c18.987,1.156,33.93,16.995,33.93,36.46v98.323
        c7.671,3.666,13.05,11.615,13.05,20.86c0,12.751-10.281,23.032-22.912,23.032c-12.671,0-22.932-10.3-22.932-23.032
        c0-9.245,5.3-17.154,12.97-20.86v-65.628c-4.303,2.092-9.045,3.467-14.066,3.845v22.812c0.159,1.893,0.319,3.726,0.319,5.579
        c0,2.032-0.159,3.905-0.319,6.017v0.558h-0.08c-2.989,37.934-32.655,68.577-70.071,72.741l0.04,0.458h-63.596h-63.676l0.02-0.458
        c-37.416-4.204-66.943-34.647-70.051-72.741h-0.04v-0.558c-0.179-2.092-0.279-3.985-0.279-6.017c0-1.833,0.159-3.646,0.279-5.579
        v-22.812c-5.021-0.398-9.842-1.753-14.086-3.845v65.628c7.69,3.666,13.07,11.615,13.07,20.86c0,12.751-10.3,23.032-22.972,23.032
        C68.686,430.727,58.446,420.406,58.446,407.655z M277.266,286.66c0-6.176-4.961-11.197-11.018-11.197
        c-6.117,0-10.958,5.021-10.958,11.197c0,6.117,4.841,11.117,10.958,11.117C272.345,297.757,277.266,292.756,277.266,286.66z
        M304.481,286.66c0-6.176-5.001-11.197-11.058-11.197c-6.037,0-10.978,5.021-10.978,11.197c0,6.117,4.961,11.117,10.978,11.117
        C299.461,297.757,304.481,292.756,304.481,286.66z M331.796,286.66c0-6.176-4.981-11.197-11.117-11.197
        c-6.077,0-11.077,5.021-11.077,11.197c0,6.117,5.001,11.117,11.077,11.117C326.816,297.757,331.796,292.756,331.796,286.66z
        M146.089,194.075c0,29.547,22.932,31.459,22.932,31.459c7.949,2.57,24.884,1.355,32.475,0c7.033-1.156,32.834-3.387,36.898-3.746
        c0.179,0,0.438,0.02,0.638,0.02c0.219,0,0.478-0.02,0.578-0.02c4.164,0.339,29.885,2.59,36.898,3.746
        c7.71,1.355,24.586,2.57,32.535,0c0,0,22.912-1.833,22.912-31.459c0,0,0-32.794-22.912-52.758
        c-22.255-19.246-55.786-23.47-68.776-23.669l0,0c-0.219,0-0.458,0-0.677,0c-0.159,0-0.398,0-0.578,0c-0.199,0-0.438,0-0.657,0
        c-0.219,0-0.418,0-0.578,0l0,0c-13.03,0.199-46.561,4.443-68.816,23.669C146.089,161.281,146.089,194.075,146.089,194.075z"/>
        </g>
</svg>
</div>
`;

